import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AvatarsTestComponent } from './avatars-test/avatars-test.component';
import { BrandsTestComponent } from './brands-test/brands-test.component';
import { AutoCompleteModule } from 'primeng/autocomplete';

@NgModule({
    declarations: [
        AvatarsTestComponent,
        BrandsTestComponent

    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        MatButtonModule,
        MatRippleModule,
        MatIconModule,
        MatFormFieldModule,
        OverlayPanelModule,
        AutoCompleteModule
    ],
    exports: [
        AvatarsTestComponent,
        BrandsTestComponent
    ],
    entryComponents: [
    ]
})
export class TestsModule { }